import { z } from '@faceup/validation'
import { SHORT_STRING_MAX_LENGTH, STRING_MIN_LENGTH } from '../validationConfig'

export const shortStringSchema = z
  .string()
  .trim()
  .min(STRING_MIN_LENGTH)
  .max(SHORT_STRING_MAX_LENGTH)
